import { Box, Button } from '@chakra-ui/react';
import { useParams } from 'react-router';
import { useEventHistory } from 'src/Pages/Event/hooks';
import { useGetCheckoutRoutesVerification } from 'src/Pages/Event/hooks/useGetCheckoutRoutesVerification';
import { useCartStore } from 'src/Pages/Event/stores';
import { useToast } from 'src/hooks';
import { useMeQuery } from 'src/hooks/queries/user';
import { useNavigatePreservingQueryParams } from 'src/hooks/useNavigateWithQueryParams';

export const CheckoutHeaderTabs = () => {
  const eventHistory = useEventHistory()
  const meQuery = useMeQuery();
  const { queryNavigation } = useNavigatePreservingQueryParams();
  const { eventID } = useParams();
  const { getEventCart } = useCartStore();
  const toast = useToast();
  

  const { isPaymentRoute, isTicketsRoute, isLoginRoute } =
    useGetCheckoutRoutesVerification();


  return (
    <Box
      display="flex"
      flexWrap="nowrap"
      overflow="scroll"
      css={{
        '&::-webkit-scrollbar': {
          display: 'none',
        },
      }}>
      <Button
        onClick={() => {
            queryNavigation('tickets')
          }
        }
        px="5"
        py="2.5"
        display="block"
        color={isTicketsRoute ? 'black' : 'gray.400'}
        borderTop="3px"
        borderTopColor={isTicketsRoute ? 'brand.500' : 'transparent'}
        rounded="none"
        variant="unstyled">
        Ingressos
      </Button>
      {!meQuery.data?.email && (
        <Button
          onClick={() => {
              const hasTicketsOnCart = getEventCart(eventID!)?.some(item => item.quantity > 0);
              if (hasTicketsOnCart) {
                eventHistory.push('login')
              } else {
                toast({
                  description: 'Adicione pelo menos um ingresso para prosseguir',
                  status: 'warning',
                  duration: 6000,
                });
              }
            }
          }
          px="5"
          py="2.5"
          display="block"
          color={isLoginRoute ? 'black' : 'gray.400'}
          borderTop="3px"
          borderTopColor={isLoginRoute ? 'brand.500' : 'transparent'}
          rounded="none"
          variant="unstyled">
          Identificação
        </Button>
      )}
      {meQuery.data?.email && (
        <Button
          onClick={() => eventHistory.push('payment')}
          px="5"
          py="2.5"
          display="block"
          color={isPaymentRoute ? 'black' : 'gray.400'}
          borderTop="3px"
          borderTopColor={isPaymentRoute ? 'brand.500' : 'transparent'}
          rounded="none"
          variant="unstyled">
          Pagamento
        </Button>
      )}
    </Box>
  );
};
